import PreviewDetailImg from 'assets/images/feature-slots/preview_detail.png';
import PreviewListImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY, getRouteName } from './common';

const MODULE_NAME = 'Purchase Orders';

const routes = [
	{
		matchRegex: '/PurchaseOrder/Create',
		name: getRouteName(MODULE_NAME, 'Create PO'),
		slots: [SLOT_KEY.SLOT_SECTION, SLOT_KEY.SLOT_SCRIPTS, SLOT_KEY.SLOT_SECTION_SUMMARY],
		image: PreviewListImg,
		parentKeys: {
			[SLOT_KEY.SLOT_SECTION_SUMMARY]: [{ key: 'detail-tab', label: 'Job Detail Summary Section' }],
			[SLOT_KEY.SLOT_SECTION]: [
				{ key: 'spo-title', label: 'SPO - Page Title' },
				{ key: 'spo-form-wrapper', label: 'SPO - Form Wrapper' },
				{ key: 'spo-bottom-bar', label: 'SPO - Bottom Bar' },
				{ key: 'job-po-title', label: 'Job PO - Page Title' },
				{ key: 'multi-job-po-title', label: 'Multi Job PO - Page Title' },
				{ key: 'job-po-form-wrapper', label: 'Job PO - Form Wrapper' },
				{ key: 'job-po-bottom-bar', label: 'Job PO - Bottom Bar' }
			]
		},
		options: {
			[SLOT_KEY.SLOT_SCRIPTS]: [
				{ key: 'MARKETPLACE_EVENT_BEFORE_SUBMIT_FORM', label: 'Before Submit Form' },
				{ key: 'MARKETPLACE_EVENT_AFTER_SUBMIT_FORM_SUCCESS', label: 'After Submit Form Successfully' }
			]
		}
	},
	{
		matchRegex: '/PurchaseOrder',
		name: getRouteName(MODULE_NAME, 'All Purchase Orders'),
		slots: [SLOT_KEY.SLOT_SECTION, SLOT_KEY.SLOT_SCRIPTS, SLOT_KEY.SLOT_V_TABLE_COLUMN],
		image: PreviewListImg,
		parentKeys: {
			[SLOT_KEY.SLOT_SECTION]: [
				{ key: 'page-title-main', label: 'Page Title' },
				{ key: 'page-title-action', label: 'Page Action' }
			],
			[SLOT_KEY.SLOT_V_TABLE_COLUMN]: [{ key: 'purchase-orders-table', label: 'Purchase Orders Table' }]
		},
		options: {
			[SLOT_KEY.SLOT_SCRIPTS]: [
				{ key: 'MARKETPLACE_EVENT_TAB_CHANGE', label: 'Before Tab Change' },
				{ key: 'MARKETPLACE_EVENT_TOGGLE_TABLE_SETTING', label: 'Before Toggle Table Setting' },
				{ key: 'MARKETPLACE_EVENT_TOGGLE_BATCHING', label: 'Before Toggle Batching' }
			]
		}
	},
	{
		matchRegex: '/PurchaseOrder/Detail/:id',
		name: getRouteName(MODULE_NAME, 'Purchase Order Detail'),
		slots: [
			SLOT_KEY.SLOT_TAB,
			SLOT_KEY.SLOT_CONTENT,
			SLOT_KEY.SLOT_SECTION_SUMMARY,
			SLOT_KEY.SLOT_SECTION,
			SLOT_KEY.SLOT_V_SECTION,
			SLOT_KEY.SLOT_V_FORM_SECTION,
			SLOT_KEY.SLOT_V_TABLE_COLUMN,
			SLOT_KEY.SLOT_SCRIPTS,
            SLOT_KEY.SLOT_V_STATIC_TABLE_COLUMN,
		],
		image: PreviewDetailImg,
		description: {
			[SLOT_KEY.SLOT_TAB]: `Embedded source: "id" must be start with prefix "MarketplaceTab_"`,
			[SLOT_KEY.SLOT_CONTENT]: `Embedded source: "id" must be start with prefix "MarketplaceTab_"`,
		},
		parentKeys: {
			[SLOT_KEY.SLOT_SECTION_SUMMARY]: [{ key: 'detail-tab', label: 'Detail Tab Summary' }],
			[SLOT_KEY.SLOT_SECTION]: [
				{ key: 'page-title', label: 'Page Title' },
				{ key: 'page-action', label: 'Page Action' },
				{ key: 'tab-details-action', label: 'Tab Details - Action' },
				{ key: 'tab-details-form-wrapper', label: 'Tab Details - Form Wrapper' },
				{ key: 'wrapper-section-outbound-email', label: 'Tab History Outbound Emails - Wrapper' }
			],
			[SLOT_KEY.SLOT_V_SECTION]: [
				{ key: 'tab-items-action', label: 'Tab Items - Action' },
				{ key: 'tab-supplier-invoices-action', label: 'Tab Supplier Invoices - Action' },
				{ key: 'wrapper-section-audit', label: 'Tab History Audit - Wrapper' },
				{ key: 'po-item-unit', label: 'PO Item Unit' },
                { key: 'po-item-delivery', label: 'PO Item Delivery' }
			],
			[SLOT_KEY.SLOT_V_FORM_SECTION]: [{ key: 'notes-tab', label: 'Tab Note - Form Wrapper' }],
			[SLOT_KEY.SLOT_V_TABLE_COLUMN]: [{ key: 'invoice-list', label: 'Invoice List' }],
            [SLOT_KEY.SLOT_V_STATIC_TABLE_COLUMN]: [
                { key: 'table-link-supplier-header', label: 'Table "Link supplier" header' },
                { key: 'table-link-supplier-body', label: 'Table "Link supplier" body' }
            ],
		},
		options: {
			[SLOT_KEY.SLOT_SCRIPTS]: [
				{ key: 'MARKETPLACE_EVENT_ADD_COLUMN_SETTING_TO_TABLE', label: 'Add Column to Table Setting' },
				{
                    key: 'MARKETPLACE_EVENT_FETCH_LIST_SUCCESS',
                    label: 'Trigger Fetch List Successfully',
                },
                {
                    key: 'MARKETPLACE_EVENT_DELETE_PO_LINE_SUCCESS',
                    label: 'After Delete PO Line Success',
                },
                {
                    key: 'MARKETPLACE_EVENT_UPDATE_PO_LINE_SUCCESS',
                    label: 'After Update PO Line Success',
                },
			]
		},
		replaceElements: {
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'quantity', label: 'PO Item Quantity' },
                { key: 'delivery-quantity', label: 'PO Item Delivery Quantity' }
            ],
        },
	},
	{
		matchRegex: '/PurchaseOrderSupplierInvoice/CreateSupplierInvoice',
		name: getRouteName(MODULE_NAME, 'Supplier Invoice/Credit - Create'),
		slots: [SLOT_KEY.SLOT_SECTION, SLOT_KEY.SLOT_V_STATIC_TABLE_COLUMN, SLOT_KEY.SLOT_SCRIPTS],
		image: PreviewDetailImg,
		parentKeys: {
			[SLOT_KEY.SLOT_SECTION]: [
				{ key: 'page-title', label: 'Page Title' },
				{ key: 'form-wrapper', label: 'Form Wrapper' },
				{ key: 'form-bottom-bar', label: 'Bottom Bar' }
			],
			[SLOT_KEY.SLOT_V_STATIC_TABLE_COLUMN]: [
				{ key: 'po-items-header', label: 'PO Items Table - Header' },
				{ key: 'po-items-body', label: 'PO Items Table - Body' }
			]
		},
		options: {
			[SLOT_KEY.SLOT_SCRIPTS]: [{ key: 'MARKETPLACE_EVENT_GET_COLUMN', label: 'Show data column in line invoice' }]
		}
	},
	{
		matchRegex: '/PurchaseOrderSupplierInvoice/SupplierInvoiceDetail/:id',
		name: getRouteName(MODULE_NAME, 'Supplier Invoice/Credit - Detail'),
		slots: [SLOT_KEY.SLOT_SECTION, SLOT_KEY.SLOT_V_TABLE_COLUMN, SLOT_KEY.SLOT_SCRIPTS],
		image: PreviewDetailImg,
		parentKeys: {
			[SLOT_KEY.SLOT_SECTION]: [
				{ key: 'page-title', label: 'Page Title' },
				{ key: 'page-action', label: 'Page Action' },
				{ key: 'form-wrapper', label: 'Form Wrapper' }
			],
			[SLOT_KEY.SLOT_V_TABLE_COLUMN]: [
				{ key: 'invoice-line-list', label: 'Invoice Line List' },
				{ key: 'credit-line-list', label: 'Credit Line List' }
			]
		},
		options: {
			[SLOT_KEY.SLOT_SCRIPTS]: [{ key: 'MARKETPLACE_EVENT_GET_COLUMN', label: 'Show data column in line invoice' }]
		}
	},
	{
		matchRegex: '/PurchaseInvoice',
		name: getRouteName(MODULE_NAME, 'All Purchase Invoice'),
		slots: [SLOT_KEY.SLOT_V_SECTION],
		image: PreviewListImg,
		parentKeys: {
			[SLOT_KEY.SLOT_V_SECTION]: [
				{ key: 'page-title', label: 'Page Title' },
				{ key: 'page-action', label: 'Page Action' }
			],
			[SLOT_KEY.SLOT_V_TABLE_COLUMN]: [
				{ key: 'invoice-list', label: 'Invoice List' },
				{ key: 'invoice-line-list', label: 'Invoice Line List' },
				{ key: 'credit-line-list', label: 'Credit Line List' }
			]
		},
		options: {
			[SLOT_KEY.SLOT_SCRIPTS]: [
				{ key: 'MARKETPLACE_EVENT_TAB_CHANGE', label: 'Before Tab Change' },
				{ key: 'MARKETPLACE_EVENT_GET_COLUMN', label: 'Show data column in line invoice' }
			]
		}
	},
	{
		matchRegex: '/StockPurchaseOrder/AutoStockReorder',
		name: getRouteName(MODULE_NAME, 'Create Stock Reorder'),
		slots: [SLOT_KEY.SLOT_SECTION, SLOT_KEY.SLOT_V_STATIC_TABLE_COLUMN],
		image: PreviewDetailImg,
		parentKeys: {
			[SLOT_KEY.SLOT_SECTION]: [
				{ key: 'page-title', label: 'Page Title' },
				{ key: 'bottom-bar', label: 'Bottom Bar' }
			],
			[SLOT_KEY.SLOT_V_STATIC_TABLE_COLUMN]: [
				{ key: 'stock-list-header', label: 'Stock List Table - Header' },
				{ key: 'stock-list-body', label: 'Stock List Table - Body' }
			]
		}
	}
];

export default routes;
